import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import AutoAPI from '../../../api/AutomationAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import ConditionView from './ConditionView';
import ModelUpdateView from './AutomationModelUpdateView';

class AutomationPreview extends React.Component {
  
  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    this.mainModel = reactLocalStorage.getObject(Const.Model);
    this.model = null;
    this.fields = [];

    this.conditions = [ { } ];
    this.updates = [ { } ];
    this.autoModel = {};
    this.autoAction = {};

    this.auto = { name: '', description: '', condition_option: 0 };
    this.state = { inApiCall: true };

    this.smsTmp = this.mainModel.sms_temp.options;
    this.emailTmp = this.mainModel.email_temp.options;
  }

  componentDidMount() { AutoAPI.get(this.id, this.onReceived, this.onFail); }
  onFail = () => this.setState({ inApiCall: false });

  onReceived = auto => {
    this.conditions = JSON.parse(auto.conditions);
    this.updates = JSON.parse(auto.updates);

    const key = Object.keys(this.mainModel).find(model =>
      this.mainModel[model].model_no === auto.model);
    this.model = this.mainModel[key];
    this.fields = FieldController.getFilterFields(this.model.fields);
    
    this.autoModel = {};
    this.autoModel.action = auto.action;
    this.autoModel.model = this.model.model_key;

    this.autoAction = {};
    this.autoAction.modelSms = auto.sms_model === Const.True;
    this.autoAction.staffSms = auto.sms_staff === Const.True;
    this.autoAction.reportSms = auto.sms_reporting === Const.True;
    this.autoAction.modelSmsTmp = this.getSmsOpt(auto.sms_tmp_model);
    this.autoAction.staffSmsTmp = this.getSmsOpt(auto.sms_tmp_staff);
    this.autoAction.reportSmsTmp = this.getSmsOpt(auto.sms_tmp_reporting);
    this.autoAction.modelEmail = auto.email_model === Const.True;
    this.autoAction.staffEmail = auto.email_staff === Const.True;
    this.autoAction.reportEmail = auto.email_reporting === Const.True;
    this.autoAction.modelEmailTmp = this.getEmailOpt(auto.email_tmp_model);
    this.autoAction.staffEmailTmp = this.getSmsOpt(auto.email_tmp_staff);
    this.autoAction.reportEmailTmp = this.getSmsOpt(auto.email_tmp_reporting);
    this.autoAction.staffNotify = auto.notify_staff === Const.True;
    this.autoAction.reportNotify = auto.notify_reporting === Const.True;
    this.autoAction.auto_call = auto.auto_call === Const.True;
    this.autoAction.meeting = auto.meeting === Const.True;
    this.autoAction.pipeline = auto.pipeline === Const.True;

    this.auto = { name: auto.name, description: auto.description, 
      condition_option: auto.condition_option  };

    this.setState({ inApiCall: false });
  }

  getSmsOpt=val=>val!== 0?this.mainModel.sms_temp.options.find(opt=>opt.value===val):val;
  getEmailOpt=val=>val!== 0?this.mainModel.email_temp.options.find(opt=>opt.value===val):val;

  render() {
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row mb-6">
              <div className="col-md-6 pb-3"><h3>{ this.auto.name }</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color"  bordered >
                  <thead><tr><th>Description</th><th>Model</th><th>Action</th></tr></thead>
                  <tbody>
                    <tr>
                      <td>{ this.auto.description }</td>
                      <td>{ this.mainModel[this.autoModel.model]
                        ? this.mainModel[this.autoModel.model].model_name : '' }</td>
                      <td>{ this.autoModel.action }</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              <div className="formhead col-md-12"><h4>Condition</h4></div>
              <ConditionView model={this.model} fields={this.fields} value={this.conditions} />

              <div className="formhead col-md-12"><h4>Updation</h4></div>
              <ModelUpdateView model={this.mainModel} value={this.updates} />

              <div className="formhead col-md-12"><h4>Automation</h4></div>
              <div className="col-md-12">
                <div className="col">
                  <div className="form-group">
                    { this.autoAction.modelSms
                      && `Send SMS to Lead. With : ${this.autoAction.modelSmsTmp.label}` }
                    { this.autoAction.staffSms
                      && `Send SMS to Sales Person. With : ${this.autoAction.staffSmsTmp.label}` }
                    { this.autoAction.reportSms
                      && `Send SMS to Reporting Sales Person.`
                        + ` With : ${this.autoAction.reportSmsTmp.label}` }
                  </div>

                  <div className="form-group">
                    { this.autoAction.modelEmail
                      && `Send Email to Lead. With : ${this.autoAction.modelEmailTmp.label}` }
                    { this.autoAction.staffEmail
                      && `Send Email to Sales Person. With : ${this.autoAction.staffEmailTmp.label}` }
                    { this.autoAction.reportEmail
                      && `Send Email to Reporting Sales Person.`
                        + ` With : ${this.autoAction.reportEmailTmp.label}` }
                  </div>

                  <div className="form-group">
                    { this.autoAction.staffNotify && 'Send Notification to Sales Person' }
                    { this.autoAction.reportNotify && 'Send Notification to Reporting Sales Person' }
                  </div>
                  
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Creations</h4></div>
              <div className="col-md-12">
                <div className="col">
                  <div className="form-group">
                    { this.autoAction.auto_call && 'Create Call' }
                    { this.autoAction.meeting && 'Create Meeting' }
                  </div>
                </div>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(AutomationPreview);
